import type { IStaticUrls } from "@/shared/common/types";
import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

interface StaticUrlsState {
  data: IStaticUrls;
}

const initialState: StaticUrlsState = {
  data: {},
};

const staticUrlsSlice = createSlice({
  name: "staticUrls",
  initialState,
  reducers: {
    setStaticUrls(state, action: PayloadAction<IStaticUrls>) {
      state.data = action.payload;
    },
  },
});

export const { setStaticUrls } = staticUrlsSlice.actions;
export default staticUrlsSlice.reducer;
